// extracted by mini-css-extract-plugin
module.exports = {"info":"TootipGuide_info__2VeN2","infoText":"TootipGuide_infoText__2kC1n","btnContainer":"TootipGuide_btnContainer__2429h","Close":"TootipGuide_Close__4QyqI"};